import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setToken, isAccessTokenValid } from "../utils/auth";
import axios from "axios";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // ✅ ตั้ง interval เช็ค token ทุก 3 นาที
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAccessTokenValid()) {
        alert("🔒 Token หมดอายุ กรุณาเข้าสู่ระบบใหม่");
        localStorage.clear(); // ✅ ล้างข้อมูลทั้งหมด หรือใช้ removeItem ถ้าเจาะจง
        navigate("/");
      }
    }, 180000); // 3 นาที

    return () => clearInterval(interval);
  }, [navigate]);

  const handleLogin = async () => {
    if (!email || !password) {
      alert("กรอก email และ password");
      return;
    }

    try {
      const res = await axios.post("https://api.superpetshop.com/api/v1/auth/login", {
        email,
        password,
      });

      const token = res.data.access_token;
      const expiresIn = res.data.expires_in; // ✅ รับ expires_in จาก backend
      setToken(token, expiresIn); // เก็บ token ใน localStorage หรือ cookie
      navigate("/menu");
    } catch (err) {
      alert("เข้าสู่ระบบไม่สำเร็จ: " + err.response?.data?.message || err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-6 rounded shadow w-full max-w-sm">
        <h2 className="text-xl font-bold mb-4 text-center">Login Staff</h2>
        <input
          className="border p-2 w-full mb-3"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="border p-2 w-full mb-3"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          onClick={handleLogin}
          className="bg-blue-500 text-white w-full p-2 rounded hover:bg-blue-600"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
